import { useTranslation } from "react-i18next"

const BAR_HEIGHTS = [28, 36, 44, 54, 66, 80, 96]

export default function DailyHabitVisual({ minutes }: { minutes: number }) {
  const { t } = useTranslation()

  return (
    <div className="vm-card w-full p-5">
      <div className="flex h-32 items-end justify-between gap-2">
        {BAR_HEIGHTS.map((height, index) => (
          <div className="flex h-full flex-1 flex-col justify-end" key={index}>
            <div
              className={`w-full origin-bottom animate-grow-up rounded-t-lg ${
                index === BAR_HEIGHTS.length - 1
                  ? "bg-vm-primary"
                  : "bg-vm-primary/25"
              }`}
              style={{
                animationDelay: `${index * 110}ms`,
                height: `${height}%`,
              }}
            />
          </div>
        ))}
      </div>

      <div className="mt-2 flex justify-between text-[11px] font-medium text-vm-muted">
        {BAR_HEIGHTS.map((_, index) => (
          <span className="flex-1 text-center" key={index}>
            {t("pages.onboarding.visuals.dailyHabit.week", {
              count: index + 1,
            })}
          </span>
        ))}
      </div>

      <div className="mt-4 flex animate-fade-up items-center justify-center gap-2 rounded-vm-md bg-vm-primary-soft px-3 py-2 text-sm font-semibold text-vm-primary-text [animation-delay:900ms]">
        ⏱️ {t("pages.onboarding.visuals.dailyHabit.badge", { minutes })}
      </div>
    </div>
  )
}
